/* eslint-disable react-hooks/rules-of-hooks */
import { useState } from 'react'

import './peyk.scss'

import { Link, useNavigate } from 'react-router-dom'

import peykLogo from '../../assets/svg/PeykLogo.png'
import { post } from '../../services/https'
import { notify } from '../../components/Toast'

import { ToastContainer } from 'react-toastify'

import loadingPic from '../../assets/svg/Loading.svg'

export default function index() {
  const [phoneNumber, setPhoneNumber] = useState(0)
  const [alertPhoneNumber, setAlertPhoneNumber] = useState(false)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const loginInHandler = (e) => {
    e.preventDefault()

    if (phoneNumber !== undefined && phoneNumber.length === 11) {
      setAlertPhoneNumber(false)
      post('/api/front/peyks/peyk/', {
        phoneNumber
      }).then(response => {
        if (response.data.data.status === false) {
          setLoading(false)
          return  notify('error', 'شما دسترسی به بخش پنل رو ندارید')
        } else if (response.data.data.status === true) {
          setLoading(false)
          localStorage.setItem('token', response.data.data.token)
          post('/api/front/sendsms/peyk', {
              phoneNumber: phoneNumber
            }, {
              'Content-Type': 'application/json'
            }).then(response => {
              if (response.data.messageFa === "پیام با موفقیت ارسال شد") {
                navigate('/peyk/verify')
                localStorage.setItem('phoneNumber', phoneNumber)
              }
            })
        }
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })      
      
    } else {
      setAlertPhoneNumber(true)
    }
  }

  return (
    <div id='peyk'>
      <ToastContainer rtl />
      <main className="countainer">
        <section className='Logo'>
          <img src={peykLogo} alt="peykLogo" />
        </section>
        <section className='from'>
          <div className="form__title">
            شماره موبایل خود را وارد کنید
          </div>
          <div className="form__input">
            <input onChange={(e) => setPhoneNumber(e.target.value)} className='form__input--ltr' type="number" placeholder='0098 ...' />
            <small style={alertPhoneNumber ? {} : { display: 'none' }}>شماره موبایل صحیح نیست</small>
          </div>
          <div className="form__message">
            کد اعتبارسنجی برایتان ارسال خواهد شد
          </div>
          <div className="from__button">
            <button onClick={loginInHandler} style={{ whiteSpace: 'nowrap' }}><span style={loading ? {display: 'none'} : {}}>ورود</span><img style={loading ? {} : {display: 'none'}} className='loadingPic' src={loadingPic} alt='loadingPic' /></button>
          </div>
          <div className="from__signUpLink">
            <Link to='/peyk/signup'>
              ثبت نام سفیر کانولی
            </Link>
          </div>
        </section>
        <section className='copyright'>
          قدرت گرفته از <Link to='https://ibills.ir'>Ibills</Link> ، توسعه توسط <Link to='https://ham-team.ir'>هم‌تیم</Link>
        </section>
      </main>
    </div>
  )
}
